import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useTanyaContext } from "stores/tanya/tanya-context";
import HomeBanner from "public/assets/home/homebanner2.png";
import BannerImage from "public/assets/bimbel-online/bimbel-banner.svg";
import BannerImageDesktop from "public/assets/bimbel-online/bimbel-banner-desktop.png";
import React, { useState } from "react";
import trackEvent from "services/mixpanel/mixpanel";
import { bannerIntentEventNames } from "services/mixpanel/tanya-events";
import { getLeadSourceFromPath } from "utils/utils";
import { PriceInfoCard } from "../price-info-card/price-info-card";
import {
  LeadGenerationImgWrapper,
  LeadGenerationSectionContainer,
  LeadGenerationSectionWrapper,
  LeadGenerationTextContainer,
  LeadGenerationTextWrapper,
  LeadGenerationTag,
  LeadGenerationTagContainer,
  Tag1,
  Tag2,
  MainContent,
  SpacerForAbsolute,
  LeadGenerationPriceButtonWrapper,
  LeadGenerationSubheading,
  LeadGenerationHeading,
  LeadGenerationHeadingSubline
} from "./hero-lead-generation-section.styles";
import { useMediaQuery } from "hooks/use-media-query/use-media-query";
import { VideoModal } from "components/video-modal/video-modal";

interface IHeroLeadGenerationSectionProps {
  onPriceInfoCTAClick?: () => void;
  buttonCTAText?: string;
  source: "Banner" | "Home" | "DaftarBimbel" | "DaftarBimbelColearn";
}

export const HeroLeadGenerationSection: React.FC<
  IHeroLeadGenerationSectionProps
> = ({ buttonCTAText, source }) => {
  const isMobile = useMediaQuery("mobile");
  const router = useRouter();
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const leadSource = getLeadSourceFromPath(router.pathname);
  const { contactMeForm } = useTanyaContext();
  const { utm_campaign, utm_source, utm_medium, utm_term, utm_content } =
    router.query;

  const handleCTAClick = () => {
    trackEvent({
      eventName: bannerIntentEventNames.primaryCTAClicked,
      payload: { leadSource }
    });

    if (true) {
      if (source === "DaftarBimbel") {
        window.location.href =
          "https://api.whatsapp.com/send/?phone=6281919187201&text=Hai%20CoLearn%2C%20saya%20ingin%20info%20bimbel%20online%20Matematika&type=phone_number&app_absent=0";
      } else if (source === "DaftarBimbelColearn") {
        window.location.href =
          "https://api.whatsapp.com/send/?phone=6281919187201&text=Hai%20CoLearn%2C%20mohon%20info%20bimbel%20online%20Matematika&type=phone_number&app_absent=0";
      } else {
        window.location.href =
          "https://wa.me/6281919187201?text=Halo%2C%20saya%20minta%20%23info%20bimbel%20online%20Matematika%20di%20CoLearn";
      }
    } else {
      contactMeForm.setContactMeFormData({
        show: true,
        metaData: {
          utm_term,
          utm_source,
          utm_medium,
          utm_campaign,
          utm_content
        }
      });
    }
  };

  const handleImageClick = () => {
    if (source === "Banner") {
      setIsVideoPlaying(true);
    }
  };

  return (
    <LeadGenerationSectionWrapper>
      <LeadGenerationSectionContainer>
        <LeadGenerationImgWrapper
          onClick={handleImageClick}
          style={{ cursor: source === "Banner" ? "pointer" : "default" }}
        >
          <Image
            src={
              source === "Banner"
                ? isMobile
                  ? BannerImage
                  : BannerImageDesktop
                : HomeBanner
            }
            alt={
              source === "Banner"
                ? "Banner description here"
                : "Bimbel online mulai 90.000 / bulan"
            }
            layout="responsive"
            sizes="(min-width: 768px) 33vw, 80vw"
            priority
          />
        </LeadGenerationImgWrapper>
        <SpacerForAbsolute
          page={source === "Banner" ? "bimbelPage" : "homePage"}
        />
        <MainContent page={source === "Banner" ? "bimbelPage" : "homePage"}>
          <LeadGenerationTextWrapper>
            <LeadGenerationTextContainer>
              {source === "Home" ? (
                <>
                  <LeadGenerationHeading>
                    Jago Matematika:
                    <LeadGenerationHeadingSubline>
                      Bangun Fondasi untuk TKA
                    </LeadGenerationHeadingSubline>
                  </LeadGenerationHeading>
                  <LeadGenerationTagContainer>
                    <Tag1>
                      <LeadGenerationTag>Bimbel Online</LeadGenerationTag>
                      <LeadGenerationTag>4 SD - 12 SMA</LeadGenerationTag>
                    </Tag1>
                    <Tag2>
                      <LeadGenerationTag>90.000/bulan</LeadGenerationTag>
                    </Tag2>
                  </LeadGenerationTagContainer>
                </>
              ) : (
                <>
                  <LeadGenerationSubheading>
                    Mewujudkan murid Indonesia <br /> yang percaya diri dan
                  </LeadGenerationSubheading>
                  <LeadGenerationHeading>
                    Paham Matematika
                  </LeadGenerationHeading>
                  <LeadGenerationTagContainer>
                    <Tag1>
                      <LeadGenerationTag>Bimbel Online</LeadGenerationTag>
                      <LeadGenerationTag>Interaksi 2-arah</LeadGenerationTag>
                    </Tag1>
                    <Tag2>
                      <LeadGenerationTag>Guru dan teman seru</LeadGenerationTag>
                    </Tag2>
                  </LeadGenerationTagContainer>
                </>
              )}
              <LeadGenerationPriceButtonWrapper>
                <PriceInfoCard
                  onCTAClick={handleCTAClick}
                  ctaTitle={
                    buttonCTAText ? buttonCTAText : "Minta info bimbel "
                  }
                  buttonColor={source === "Home" ? "#00CB88" : undefined}
                />
              </LeadGenerationPriceButtonWrapper>
            </LeadGenerationTextContainer>
          </LeadGenerationTextWrapper>
        </MainContent>
        {isVideoPlaying && (
          <VideoModal
            onClose={() => setIsVideoPlaying(false)}
            videoUrl="https://www.youtube.com/watch?v=Z64Z-iUgu0s"
          />
        )}
      </LeadGenerationSectionContainer>
    </LeadGenerationSectionWrapper>
  );
};
